// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loader-module__overlay___3-edH","overlayAbsolute":"Loader-module__overlayAbsolute___105gR","loader":"Loader-module__loader___19r4j"};